import { LegalPage, Section, SubSection } from "./LegalPage";

export function TermsOfService() {
  return (
    <LegalPage title="Terms of Service" lastUpdated="March 20, 2026">
      <Section title="1. Acceptance of Terms">
        <p>By accessing or using SimSense ("the Service"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree, do not use the Service.</p>
      </Section>

      <Section title="2. Description of Service">
        <p>SimSense is an iRacing telemetry analysis platform that provides:</p>
        <ul>
          <li>Telemetry data extraction and visualization from .ibt files</li>
          <li>Coaching reports and performance analysis</li>
          <li>Lap comparison and session tracking</li>
          <li>Marketplace for community and commercial setup sharing</li>
          <li>Desktop agent for automated telemetry upload</li>
        </ul>
      </Section>

      <Section title="3. Account Registration">
        <ul>
          <li>You must be at least 13 years old to create an account.</li>
          <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
          <li>You agree to provide accurate information during registration.</li>
          <li>One person may not maintain more than one free account.</li>
        </ul>
      </Section>

      <Section title="4. Subscription Plans">
        <SubSection title="Free Tier">
          <ul>
            <li>Core telemetry tools at no cost</li>
            <li>3 coaching reports per month</li>
            <li>Basic coaching observations</li>
            <li>6-month data retention</li>
          </ul>
        </SubSection>
        <SubSection title="Pro Tier ($5/month)">
          <ul>
            <li>Unlimited advanced coaching reports</li>
            <li>Corner grading system</li>
            <li>Extended data retention</li>
            <li>Priority processing</li>
          </ul>
        </SubSection>
        <p>Prices are subject to change with 30 days notice to active subscribers.</p>
      </Section>

      <Section title="5. User Content & Data">
        <SubSection title="Your Telemetry Data">
          <ul>
            <li>You retain ownership of your telemetry data (.ibt files and derived analysis).</li>
            <li>By uploading data, you grant SimSense a limited license to process, store, and display your data back to you.</li>
            <li>If you enable sharing, your data may be visible to other authenticated users per your privacy settings.</li>
          </ul>
        </SubSection>
        <SubSection title="Marketplace Content">
          <ul>
            <li>Setup files you publish on the marketplace remain your intellectual property.</li>
            <li>By publishing, you grant SimSense a license to host, distribute, and display your content on the platform.</li>
            <li>See the Creator Agreement for full marketplace terms.</li>
          </ul>
        </SubSection>
      </Section>

      <Section title="6. Prohibited Conduct">
        <p>You agree not to:</p>
        <ul>
          <li>Upload malicious files or content designed to harm other users</li>
          <li>Impersonate other users, teams, or setup brands</li>
          <li>Scrape, reverse-engineer, or automated-access the platform without authorization</li>
          <li>Use the service to violate iRacing's Terms of Service or End User License Agreement</li>
          <li>Create multiple free accounts to circumvent usage limits</li>
          <li>Share or redistribute commercial setups that you do not own</li>
        </ul>
      </Section>

      <Section title="7. Intellectual Property">
        <ul>
          <li>SimSense, the SimSense logo, and "Sense Score" are trademarks of SimSense.</li>
          <li>The SimSense platform, including its code, design, and analysis algorithms, is proprietary.</li>
          <li>iRacing is a trademark of iRacing.com Motorsport Simulations, LLC. SimSense is not affiliated with or endorsed by iRacing.</li>
        </ul>
      </Section>

      <Section title="8. Disclaimer of Warranties">
        <p><strong>THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND. SIMSENSE DOES NOT GUARANTEE THAT THE SERVICE WILL BE UNINTERRUPTED, ERROR-FREE, OR THAT COACHING RECOMMENDATIONS WILL IMPROVE YOUR PERFORMANCE.</strong></p>
      </Section>

      <Section title="9. Limitation of Liability">
        <p><strong>SIMSENSE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES ARISING FROM YOUR USE OF THE SERVICE, INCLUDING BUT NOT LIMITED TO LOST DATA, LOST PROFITS, OR DAMAGE TO YOUR IRACING ACCOUNT.</strong></p>
      </Section>

      <Section title="10. Termination">
        <ul>
          <li>You may cancel your account at any time.</li>
          <li>SimSense may suspend or terminate accounts that violate these Terms.</li>
          <li>Upon termination, your data will be deleted within 30 days unless required by law.</li>
        </ul>
      </Section>

      <Section title="11. Changes to Terms">
        <p>SimSense may update these Terms at any time. Continued use after changes constitutes acceptance. Material changes will be communicated via email or in-app notification.</p>
      </Section>

      <Section title="12. Contact">
        <p>For questions about these Terms, contact: <strong>support@outlierspeedco.com</strong></p>
      </Section>
    </LegalPage>
  );
}
